module.exports = __webpack_public_path__ + "img/Ciclismo-2026.ba5b4cd8.png";